import assert from './assert'

export const personasCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/new`
}

export const personasExplorerPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/explorer`
}

export const personasProfilesPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/profiles`
}

export const personasProfilePath = args => {
  assert(args, ['workspaceSlug', 'profileId'])
  return `/${args.workspaceSlug}/personas/profile/${args.profileId}`
}

export const personasDestinationsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/destinations`
}

export const personasDestinationSettingsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/destinations/${args.destinationId}`
}

export const personasTraitsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/traits`
}

export const personasTraitsCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/traits/new`
}

export const personasTraitPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `/${args.workspaceSlug}/personas/traits/${args.traitId}/overview`
}

export const personasTraitBuilderPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `/${args.workspaceSlug}/personas/traits/${args.traitId}/edit`
}

export const personasTraitSettingsPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `/${args.workspaceSlug}/personas/traits/${args.traitId}/settings`
}

export const personasAudiencesPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/audiences`
}

export const personasAudiencesCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/audiences/new`
}

export const personasAudienceOverviewPath = args => {
  assert(args, 'workspaceSlug')
  assert(args, 'audienceId')
  return `/${args.workspaceSlug}/personas/audiences/${args.audienceId}/overview`
}

export const personasAudienceBuilderPath = args => {
  assert(args, ['workspaceSlug', 'audienceId'])
  return `/${args.workspaceSlug}/personas/audiences/${args.audienceId}/edit`
}

export const personasAudienceSettingsPath = args => {
  assert(args, ['workspaceSlug', 'audienceId'])
  return `/${args.workspaceSlug}/personas/audiences/${args.audienceId}/settings`
}

export const personasSettingsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/settings`
}

export const personasSettingsSourcesPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/settings/sources`
}

export const personasSettingsAPIAccessPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/settings/api-access`
}
